<template>
    <div class="card-etiquetas-pedido-aguardando-aprovacao">
        <g-card
        :temCabecalho="false"
        :expansivel="false"
        >
            <div class="header-etiquetas-pedido-aguardando-aprovacao">
                <div class="header-titulo-voltar">
                    <g-button
                    class="buscar-button-header"
                    largura="35px"
                    icone="icone_voltar.svg"
                    negritoTexto
                    tamanhoIcone="10px"
                    cor="#FFFFFF"
                    altura="30px"
                    :sombreado="false"
                    @click="voltar()"
                    />

                <div class="card-titulo-etiquetas"> Etiqueta do Pedido</div>
                </div>

                <div class="print header-icons">
                    <g-button
                    class="botoes"
                    altura="35px"
                    largura="35px"
                    tamanhoIcone="15px"
                    icone="icone_print.svg"
                    >
                    </g-button>
                </div>
            </div>

                <div class="grupo-dados-etiqueta">
                    <div class="dados-etiqueta-pedido dados-tipo">
                        <div class="dados-etiqueta-titulo grupo"> Pedido: </div>
                        <div class="conteudo"> 	{{this.codigoPedido}} </div>
                    </div>

                    <div class="dados-etiqueta-cliente dados-tipo">
                        <div class="dados-etiqueta-titulo grupo"> Cliente: </div>
                        <div class="conteudo"> {{this.nomeFantasia}} </div>
                    </div>

                    <div class="dados-etiqueta-produto dados-tipo">
                        <div class="dados-etiqueta-titulo grupo"> Produto: </div>
                        <div class="conteudo"> {{this.nomeProduto}} </div>
                    </div>
                </div>
                <div class="linha-separacao"></div>
        </g-card>
    </div>
</template>

<script>
import EtiquetaPedidoAguardandoAprovacao from './EtiquetaPedidoAguardandoAprovacao.js'
export default EtiquetaPedidoAguardandoAprovacao
</script>

<style scoped>
.card-titulo-etiquetas {
    color: #4f2c19;
    font-weight: bold;
    font-size: 1.1rem;
}

.header-titulo-voltar {
  width: 100%;
  display: flex;
  align-items: flex-end;
}

.grupo {
  color: #4f2c19;
  text-align: left;
  font-family: "MontSerrat";
  font-weight: bold;
  font-size: 18px;
  margin-right: 8px;
}

.conteudo {
  color: #8a8a8a;
  text-align: left;
  font-family: "MontSerrat";
  margin-bottom: 10px;
  word-break: break-word;
}

.dados-tipo{
    display: flex;
    align-items: baseline;
}


@media(min-width:310px) {
.header-etiquetas-pedido-aguardando-aprovacao {
    width: 100%;
    display: flex;
    justify-content: space-between;
    padding: 10px 0;
    border-bottom: 1px solid #f0f0f0;
}
.grupo-dados-etiqueta {
    display: grid;
    margin-top: 30px;
}
}

@media(min-width:368px) {}

@media(min-width:600px) {
.dados-etiqueta-pedido { grid-area: 1 / 2 / 2 / 3; }
.dados-etiqueta-cliente { grid-area: 2 / 2 / 3 / 3; }
.dados-etiqueta-produto { grid-area: 3 / 2 / 4 / 3; }
}

@media(min-width:801px) {}

@media(min-width:1025px) {}

@media(min-width:1285px) {}

@media(min-width:1500px) {}
</style>